export type FormCategory =
  // Contact — 6 catégories fines (analytics important)
  | 'contact-essai-gratuit'
  | 'contact-rdv'
  | 'contact-devis'
  | 'contact-lp-sea'
  | 'contact-demo'
  | 'contact-test'
  // Newsletter (2)
  | 'newsletter-footer'
  | 'newsletter-cta-blog'
  // Ressources — regroupées par stage funnel
  | 'ressource-bofu'
  | 'ressource-mofu'
  | 'ressource-tofu'
  // Fallback pour forms non mappés (détectés mais pas encore catégorisés)
  | 'unknown';

/**
 * Registry complet des 31 forms HSFC actifs (export HubSpot 2026-04-21).
 * Clé = formId HubSpot (UUID), Valeur = catégorie analytique.
 */
export const FORM_REGISTRY: Readonly<Record<string, FormCategory>> = {
  // ─── Contact (6) ─────────────────────────────────────────────
  '3f1fe364-c53c-433d-9209-7eada4d9c5aa': 'contact-essai-gratuit', // CONTACT_ESSAI_GRATUIT_MULTISTEP_2026
  'ae7699ba-a632-41e3-bcc6-e7761236fe18': 'contact-rdv',           // CONTACT_RDV_MULTISTEP_2026
  '72ba53cf-3ab6-4471-a284-6a04718367fd': 'contact-devis',         // CONTACT_DEVIS_MULTISTEP_2026
  'dee970e1-8a6e-4404-95a3-6f718031d687': 'contact-lp-sea',        // CONTACT_LP_SEA_2026
  '5db1eac1-78c3-4ced-ba89-dd8296d3cfdb': 'contact-demo',          // CONTACT_DEMO_MULTISTEP_2026
  '09d06b7e-fda8-4ba1-8cc5-33cec5249fd8': 'contact-test',          // CONTACT_TEST_MULTISTEP_2026

  // ─── Newsletter (2) ──────────────────────────────────────────
  '8f2274dc-3492-4f13-a316-517c4a98d963': 'newsletter-footer',     // NL_FOOTER_2026
  '0af07a7c-e422-47b0-854d-4b4fb55baa98': 'newsletter-cta-blog',   // NL_CTA_BLOG_2026

  // ─── Ressources BOFU (1) ─────────────────────────────────────
  '08250147-6163-4d83-86f4-b8a69671cc71': 'ressource-bofu',        // BOFU_GUIDE_CAHIER_CHARGES_ATS_2026

  // ─── Ressources MOFU (17) ────────────────────────────────────
  'a891f619-cf13-4847-bb7e-ba0076406fb5': 'ressource-mofu',        // MOFU_MODELE_REFUS_2026
  '599821e0-9077-43d5-ad3f-e4e7575d754a': 'ressource-mofu',        // MOFU_CHECKLIST_ONBOARDING_2026
  '3531c6c7-3082-4204-9e02-6c21fc28e6d9': 'ressource-mofu',        // MOFU_MESSAGE_REMERCIEMENT_2026
  'b80db805-7e23-4cf2-b5e8-b7f6c4ecc139': 'ressource-mofu',        // MOFU_PRISE_REFERENCE_2026
  '2ddab849-33e1-4169-95e1-1bf3dd878824': 'ressource-mofu',        // MOFU_COPYWRITING_2026
  'fda78f60-8a0f-4f31-a601-e4088e1ec9a3': 'ressource-mofu',        // MOFU_SCORECARD_2026
  'fe8afbd5-8b97-4e49-bfc7-fad1396fa0db': 'ressource-mofu',        // MOFU_FICHE_POSTE_2026
  '8e50bdc5-f62b-45ea-87ef-aee2e6085296': 'ressource-mofu',        // MOFU_COMPTE_RENDU_ENTRETIEN_2026
  'b05ca432-8560-49e8-97e3-d2094d49ad72': 'ressource-mofu',        // MOFU_MODELE_PROMESSE_EMBAUCHE_2026
  'e1d717fb-bf7e-48fb-a66b-75ab3ed343d4': 'ressource-mofu',        // MOFU_RAPPORT_ETONNEMENT_2026
  'bf96af5c-41da-4f0f-9c7f-9c05b1913dd2': 'ressource-mofu',        // MOFU_WEBINAR_MS_OFFRE_EMPLOI_2026
  '20f330dd-310d-422a-a35a-b06c02065909': 'ressource-mofu',        // MOFU_WEBINAR_MS_STRUCTURER_ENTRETIEN_EMBAUCHE_2026
  '5447ade4-3be2-466b-abbd-31870176da10': 'ressource-mofu',        // MOFU_WEBINAR_MS_PRISE_BESOIN_RECRUTEMENT_2026
  '35d2ea67-d442-4c19-9bd0-20654f52f2f7': 'ressource-mofu',        // MOFU_WEBINAR_MS_CONSTRUIRE_PROCESS_RECRUTEMENT_2026
  'd1cab6d7-e0ca-4e67-9791-1cb5a8332547': 'ressource-mofu',        // MOFU_WEBINAR_MS_PRISE_REFERENCE_2026
  '1dbf0e72-c6ed-464b-9ac7-8abb292675dc': 'ressource-mofu',        // MOFU_WEBINAR_MS_BIAIS_COGNITIF_2026
  '6b3909d0-a67d-4a4a-8818-8063fab44dc7': 'ressource-mofu',        // MOFU_GRILLE_ENTRETIEN_EMBAUCHE_2026

  // ─── Ressources TOFU (5) ─────────────────────────────────────
  '0e58b7a4-fb60-4134-8b1c-4766c049412f': 'ressource-tofu',        // TOFU_MARQUE_EMPLOYEUR_2026
  '0cf76598-fe0b-4781-933b-270460d79a1b': 'ressource-tofu',        // TOFU_XP_CANDIDAT_2026
  '81df020c-58f0-4a23-ad76-565e9f1a2425': 'ressource-tofu',        // TOFU_RECRUTEMENT_MODE_PROJET_2026
  '7cbcf120-1c7b-46b3-ae6d-97f191c88cdb': 'ressource-tofu',        // TOFU_MODELE_OFFRE_MANAGER_2026
  'b38e0709-7957-40a1-963d-3c60436a58f7': 'ressource-tofu',        // TOFU_PROCESSUS_RECRUTEMENT_ILLUSTRE_2026
};

/**
 * Retourne la catégorie d'un form par son formId HubSpot.
 * Retourne 'unknown' si le formId n'est pas dans le registry.
 */
export function getFormCategory(formId: string): FormCategory {
  return FORM_REGISTRY[formId] ?? 'unknown';
}
